import {Routes} from '@angular/router';
import {DashboardComponent} from '@dashboard/dashboard/dashboard.component';
import {UserType} from '@services/resource/user-type';
import {StartupComponent} from '@dashboard/startup/startup.component';
import {ProductPreviewComponent} from '@dashboard/product-preview/product-preview.component';
import {WelcomeComponent} from '@dashboard/welcome/welcome.component';
import {ProductEditorComponent} from '@dashboard/product-editor/product-editor.component';
import {UserRoleRouteGuard} from '@common/messe-ui-toolkit';
import {StartupDashboardRelativeRouteBuilder} from '@util/route-builder';

export const STARTUP_DASHBOARD_ROUTES: Routes = [
  {
    path: '',
    component: DashboardComponent,
    data: {allowedUserGroups: UserType.IP},
    canActivate: [UserRoleRouteGuard],
    children: [
      {path: '', pathMatch: 'full', redirectTo: StartupDashboardRelativeRouteBuilder.welcome().buildRelative()},
      {path: StartupDashboardRelativeRouteBuilder.welcome().buildRelative(), component: WelcomeComponent},
      {path: StartupDashboardRelativeRouteBuilder.profile().buildRelative(), component: StartupComponent},
      {path: StartupDashboardRelativeRouteBuilder.product().buildRelative(), component: ProductEditorComponent},
      {path: StartupDashboardRelativeRouteBuilder.preview().buildRelative(), component: ProductPreviewComponent},
    ],
  },
];
